// Client wrapper for the comms Cloud Functions. The browser only composes +
// selects; recipient resolution, opt-out suppression, and sending happen
// server-side. Passes the active clubId so Golf Elite reads the right tenant.
import { getFunctions, httpsCallable } from 'firebase/functions'
import { app } from './firebase.js'
import { getActiveClubId } from './tenant.js'

const fns = () => getFunctions(app, 'us-central1')

export async function sendComms({ tournamentId, channel = 'email', subject = '', body = '', filter = {} }) {
  const { data } = await httpsCallable(fns(), 'sendCommsBatch')({
    clubId: getActiveClubId(), tournamentId, channel, subject, body, filter, origin: window.location.origin,
  })
  return data || { total: 0, sent: 0, failed: 0 }
}
